import { render, staticRenderFns } from "./widgetPieChart.vue?vue&type=template&id=8ea00c7e"
import script from "./widgetPieChart.vue?vue&type=script&lang=js"
export * from "./widgetPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports